import { applyLinebreakers } from ".";
import { getElem } from "../utils";
import { dict_TLs, isoLang, nameInSpreadsheet, nodeName } from "./translations";

export let ISO: isoLang = 'en';
export function translateHTML(vforcedISO?:isoLang) {
    ISO = vforcedISO ? vforcedISO : grabISO();
    getElem("age-gate-confirmAgeCTA").innerHTML = `${ applyLinebreakers (grabTL("confirmAgeCTA"), [27, 24, 24]) }`; // 29, 24, 24
    getElem("age-gate-tapBoxCTA").innerHTML = `${ grabTL("tapBoxCTA") }`;
    if(ISO && ISO === "ar") {
        getElem("age-gate-confirmAgeCTA").dir = "rtl";
        getElem("age-gate-tapBoxCTA").dir = "rtl";
    } else {
        getElem("age-gate-confirmAgeCTA").dir= "ltr";
        getElem("age-gate-tapBoxCTA").dir = "ltr";
    }
}

export function grabTL(KEY: nodeName) {
    const name = nameInSpreadsheet[ISO];
    const log = getElem("log");
    log.innerHTML = 'Log:' + navigator.language + ' = ' + ISO;
    return dict_TLs[name][KEY];
}

export function grabISO(): isoLang {
    let ISO = (navigator.language || 'en-GB');
    let allowedISO: isoLang = 'en';

    // Check ISO as full string, then split and check for dialects
    if(ISO in nameInSpreadsheet) {
        allowedISO = ISO as isoLang;
    } else {
        ISO = ISO.split('-')[0];
        if(ISO in nameInSpreadsheet) allowedISO = ISO as isoLang;
    }

    return allowedISO;
}


